import { AdresseModel } from './Adresse';
import { User } from '../api/User/User';
import { AppUtils } from '../../utils/index';
/**
 * Represents the personal data block of an enclosure form.
 */
export class PersonalDataModel {
	private mitgliedsnummer: string;
	private telefonGeschaeftlichNummer: string;
	private telefonGeschaeftlichVorwahl: string;
	private telefonNummer: string;
	private telefonVorwahl: string;
	private email: string;
	private geburtsdatum: string;
	private adresse: AdresseModel;
	private beguenstigter: string;
	private firma: string;
	private nachname: string;
	private vorname: string;
	private anredeKennzeichen: number;
	private title: string;
	constructor() {
		this.Adresse = new AdresseModel();
	}
	/**
	 * Salutation text.
	 *
	 * @return "Frau" or "Herr".
	 * @deprecated use AnredeKennzeichen instead
	 */
	get Anrede(): string {
		// eslint-disable-next-line eqeqeq
		return (this.anredeKennzeichen == 1 ? 'Herr' : 'Frau');
	}

	/**
	 * Salutation flag.
	 *
	 * @return 1 for 'Herr', 2 for 'Frau', 3 for "Familie", 4 for "Firma".
	 */
	get AnredeKennzeichen(): number {
		return this.anredeKennzeichen;
	}

	/**
	 * Salutation flag.
	 *
	 * @param value 1 for 'Herr', 2 for 'Frau', 3 for "Familie", 4 for "Firma".
	 */
	set AnredeKennzeichen(value: number) {
		this.anredeKennzeichen = value;
	}

	get Titel(): string {
		return this.title;
	}

	set Titel(value: string) {
		this.title = value;
	}

	get Vorname(): string {
		return this.vorname;
	}

	set Vorname(value: string) {
		this.vorname = value;
	}

	get Mitgliedsnummer(): string {
		return this.mitgliedsnummer;
	}

	set Mitgliedsnummer(value: string) {
		this.mitgliedsnummer = value;
	}

	get Nachname(): string {
		return this.nachname;
	}

	set Nachname(value: string) {
		this.nachname = value;
	}

	get Firma(): string {
		return this.firma;
	}

	set Firma(value: string) {
		this.firma = value;
	}

	get Beguenstigter(): string {
		return this.beguenstigter;
	}

	set Beguenstigter(value: string) {
		this.beguenstigter = value;
	}

	/**
	 * The address object of the enclosure applicant.
	 */
	get Adresse(): AdresseModel {
		return this.adresse;
	}

	/**
	 * The address object of the enclosure applicant.
	 */
	set Adresse(value: AdresseModel) {
		this.adresse = value;
	}

	/**
	 * Birthday in iso format.
	 */
	get Geburtsdatum(): string {
		return this.geburtsdatum;
	}

	/**
	 * Birthday in iso format.
	 */
	set Geburtsdatum(value: string) {
		this.geburtsdatum = value;
	}

	get Email(): string {
		return this.email;
	}

	set Email(value: string) {
		this.email = value;
	}

	get TelefonVorwahl(): string {
		return this.telefonVorwahl;
	}

	set TelefonVorwahl(value: string) {
		this.telefonVorwahl = value;
	}

	get TelefonNummer(): string {
		return this.telefonNummer;
	}

	set TelefonNummer(value: string) {
		this.telefonNummer = value;
	}

	get TelefonGeschaeftlichVorwahl(): string {
		return this.telefonGeschaeftlichVorwahl;
	}

	set TelefonGeschaeftlichVorwahl(value: string) {
		this.telefonGeschaeftlichVorwahl = value;
	}

	get TelefonGeschaeftlichNummer(): string {
		return this.telefonGeschaeftlichNummer;
	}

	set TelefonGeschaeftlichNummer(value: string) {
		this.telefonGeschaeftlichNummer = value;
	}

	public toString(): string {
		return JSON.stringify(this);
	}

	/**
 * Takes over fields from the user object except adress, if not already filled in the model.
 * Non editable fields are always filled from the user.
 *
 * @param user the user object to merge. Must not be null.
 * @param baseDataEditable flag, whether the base data (Anrede, Vorname, Nachnachme, Geburtsdatum) is editable.
 */
	public mergeWithUserExceptAdress(user: User, baseDataEditable: boolean, advertisingMode = false): void {
		this.mergePersonalUserData(user, baseDataEditable, advertisingMode);
	}

	/**
	 * Takes over fields from the user object, if not already filled in the model.
	 * Non editable fields are always filled from the user.
	 *
	 * @param user the user object to merge. Must not be null.
	 * @param baseDataEditable flag, whether the base data (Anrede, Vorname, Nachnachme, Geburtsdatum) is editable.
	 */
	public mergeWithUser(user: User, baseDataEditable: boolean, advertisingMode = false): void {
		this.mergePersonalUserData(user, baseDataEditable, advertisingMode);
		this.Adresse.mergeWithUser(user, advertisingMode);
	}

	private mergePersonalUserData(user: User, baseDataEditable: boolean, advertisingMode = false): void {
		if (user.MglNo && (!this.Mitgliedsnummer || advertisingMode)) {
			this.Mitgliedsnummer = user.MglNo;
		}
		if (user.UserData.Anrede && (!this.AnredeKennzeichen || !baseDataEditable)) {
			this.AnredeKennzeichen = user.UserData.Anrede;
		}
		if (user.UserData.Vorname && (!this.Vorname || !baseDataEditable)) {
			this.Vorname = user.UserData.Vorname;
		}
		if (user.UserData.Titel && (!this.Titel || !baseDataEditable)) {
			this.Titel = user.UserData.Titel;
		}
		if (user.UserData.Nachname && (!this.Nachname || !baseDataEditable)) {
			this.Nachname = user.UserData.Nachname;
		}
		if (user.UserData.Firma && (!this.Firma || advertisingMode)) {
			this.Firma = user.UserData.Firma;
		}
		if (user.UserData.Beguenstigter && (!this.Beguenstigter || advertisingMode)) {
			this.Beguenstigter = user.UserData.Beguenstigter;
		}
		if (user.UserData.Geburtsdatum && (!this.Geburtsdatum || !baseDataEditable)) {
			this.Geburtsdatum = user.UserData.Geburtsdatum;
		}
		if (user.UserData.Email && (!this.Email || advertisingMode)) {
			this.Email = user.UserData.Email;
		}
		if (user.UserData.Telefon && user.UserData.Telefon.Prefix && (!this.TelefonVorwahl || advertisingMode)) {
			this.TelefonVorwahl = user.UserData.Telefon.Prefix;
		}
		if (user.UserData.Telefon && user.UserData.Telefon.Suffix && (!this.TelefonNummer || advertisingMode)) {
			this.TelefonNummer = user.UserData.Telefon.Suffix;
		}
		if (user.UserData.TelGesch && user.UserData.TelGesch.Prefix && (!this.TelefonGeschaeftlichVorwahl || advertisingMode)) {
			this.TelefonGeschaeftlichVorwahl = user.UserData.TelGesch.Prefix;
		}
		if (user.UserData.TelGesch && user.UserData.TelGesch.Suffix && (!this.TelefonGeschaeftlichNummer || advertisingMode)) {
			this.TelefonGeschaeftlichNummer = user.UserData.TelGesch.Suffix;
		}
	}

	/**
	 * Creates a new PersonalDataModel object and copies the values from the provided data object (or other PersonalData model) to the created PersonalDataModel.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): PersonalDataModel { //NOSONAR
		return AppUtils.Helper.createFromMap(dataObject, PersonalDataModel, (key: string, value: any) => {
			if (key.toLowerCase() === 'adresse') {
				return AdresseModel.createFromObject(value);
			} else {
				return value;
			}
		});
	}
}
